import "antd/es/input/style";
import _Input from "antd/es/input";
import withFieldWrap from '../../utils/withFieldWrap';
export default withFieldWrap(_Input);